import * as React from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  createOfferAsync,
  getProductListAsync,
  getUserDetailsAsync,
} from './OfferStore/offerStoreSlice';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflowY: 'scroll',
};

const AddOfferForm = ({ fetchDefaultData, handleClose }) => {
  const [title, setTitle] = React.useState(null);
  const [amount, setAmount] = React.useState(null);
  const [domain, setDomain] = React.useState(null);
  const [expire, setExpire] = React.useState(null);
  // const [userIds, setUserIds] = React.useState([]);
  const [emailIds, setEmailIds] = React.useState([]);
  const [productIds, setProductIds] = React.useState([]);
  const [userName, setUserName] = React.useState('');
  const [show, setShow] = React.useState(true);
  const [page, setPage] = React.useState(1);

  const { buzzUsers, productList, count } = useSelector((state) => {
    const { offerReducer } = state;
    return {
      buzzUsers: state.buzz.users,
      count: state.buzz.users.length,
      productList: offerReducer.productList && offerReducer.productList.data,
    };
  });

  const users = React.useMemo(() => {
    if (userName)
      return buzzUsers.filter(({ name }) => RegExp(userName, 'i').test(name));
    else return buzzUsers;
  }, [userName]);

  const dispatch = useDispatch();
  const handleCreateOffer = async () => {
    try {
      let payload = {
        title: title,
        domain: domain,
        amount: +amount,
        expiredAt: expire,
      };
      if (domain === 'USER') {
        // payload.userIds = userIds;
        payload.emailIds = emailIds;
      }
      if (domain === 'PRODUCT') {
        payload.productIds = productIds;
      }
      dispatch(createOfferAsync(payload))
        .unwrap()
        .then((res) => {
          toast.success(`Offer has been created successully!`);
          fetchDefaultData();
          handleClose();
        });
    } catch (error) {
      toast.error('Offer could not be created!');
    }
  };

  const getCheck = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      // setUserIds([...userIds, value]);
      setEmailIds([...emailIds, value]);
    } else {
      // setUserIds(userIds.filter((e) => e !== value));
      setEmailIds(emailIds.filter((e) => e !== value));
    }
  };

  const getProductCheck = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setProductIds([...productIds, value]);
    } else {
      setProductIds(productIds.filter((e) => e !== value));
    }
  };

  React.useEffect(() => {
    fetchData();
    getData();
  }, []);

  const fetchData = () => {
    try {
      dispatch(
        getUserDetailsAsync({
          params: {
            name: '',
          },
        })
      )
        .unwrap()
        .then(() => {
          // toast.success('All Offer Details fetched successfully.');
        });
    } catch (error) {
      toast.error(
        'Users Details could not be fetched. Please try again later!'
      );
    }
  };

  const getData = () => {
    try {
      dispatch(getProductListAsync())
        .unwrap()
        .then(() => {
          // toast.success('All Offer Details fetched successfully.');
        });
    } catch (error) {
      toast.error(
        'Product Details could not be fetched. Please try again later!'
      );
    }
  };

  const handleSearchUser = () => {
    // API call
    // dispatch(
    //   getUserDetailsAsync({
    //     params: {
    //       name: userName,
    //     },
    //   })
    // )
    //   .unwrap()
    //   .then((res) => {
    //     // toast.success('All Offer Details fetched successfully.');
    //   })
    //   .catch((err) => {
    //     toast.error(err.message);
    //   });
  };

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getUserDetailsAsync({
          params: { page: val, limit: 10 },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All offers were fetched successfully!');
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  return (
    <Box sx={style}>
      {show ? (
        <Box>
          <Typography>Add Offer</Typography>
          <Box alignItems="center">
            <Box my={2}>
              <TextField
                required
                id="outlined-basic"
                label="Title"
                variant="outlined"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                size="small"
                fullWidth
              />
            </Box>

            <Box my={2} display="flex" alignItems="center">
              <TextField
                required
                id="outlined-basic"
                label="Amount in %"
                variant="outlined"
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                size="small"
                fullWidth
              />
            </Box>

            <Box my={2} display="flex" alignItems="center">
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel id="demo-select-small-label">Type*</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  label="Type*"
                  required
                  value={domain}
                  onChange={(e) => setDomain(e.target.value)}
                  fullWidth>
                  <MenuItem value={'SITE'}>SITE</MenuItem>
                  <MenuItem value={'USER'}>USER</MenuItem>
                  <MenuItem value={'PRODUCT'}>COURSE</MenuItem>
                </Select>
              </FormControl>
            </Box>
            {domain === 'USER' ? (
              <Box>
                <Button variant="contained" onClick={() => setShow(false)}>
                  Select User
                </Button>
                <Box my={2} display="flex" alignItems="center">
                  <TextField
                    required
                    id="selectedUsers"
                    label="Selected Users"
                    variant="outlined"
                    type="string"
                    value={emailIds.join(', ')}
                    // onChange={(e) => setAmount(e.target.value)}
                    disabled={true}
                    size="small"
                    fullWidth
                  />
                </Box>
              </Box>
            ) : domain === 'PRODUCT' ? (
              <Box>
                <Button variant="contained" onClick={() => setShow(false)}>
                  Select Course
                </Button>
              </Box>
            ) : // <Box>
            //   <FormGroup>
            //     {users &&
            //       users.map((item) => (
            //         <FormControlLabel
            //           control={<Checkbox />}
            //           label={item.name}
            //           value={item._id}
            //           onChange={(e) => getCheck(e)}
            //         />
            //       ))}
            //   </FormGroup>
            // </Box>
            null}
            <Box my={2} display="flex" alignItems="center">
              <TextField
                id="date"
                label="Expire Date*"
                type="date"
                fullWidth
                size="small"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                value={expire}
                onChange={(e) => setExpire(e.target.value)}
              />
            </Box>
          </Box>
          {console.log('offer', title, domain, amount, expire)}
          <Box my={2}>
            <Button
              variant="contained"
              color="primary"
              disabled={
                title === null ||
                title === '' ||
                amount === null ||
                amount === '' ||
                amount > 99 ||
                domain === null ||
                domain === '' ||
                expire === null ||
                expire === '' ||
                (domain === 'USER' && emailIds.length === 0) ||
                (domain === 'PRODUCT' && productIds.length === 0)
                  ? true
                  : false
              }
              onClick={handleCreateOffer}>
              Add Offer
            </Button>
          </Box>
        </Box>
      ) : (
        <Box width={1100} height={460}>
          {domain === 'USER' ? (
            <>
              <Typography>Select User For Offer</Typography>
              <Box display="flex">
                <Box flex={4} my={2}>
                  <BuzzInput
                    size="small"
                    placeholder="Search by user name"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    onSubmitEditing={handleSearchUser}
                  />
                </Box>
                <Box flex={1} justifyContent={'right'} my={2} display={'flex'}>
                  <Button
                    variant="outlined"
                    onClick={() => setShow(true)}
                    color="primary">
                    Back
                  </Button>
                  <Box mx={1} />
                  <Button
                    variant="contained"
                    onClick={() => setShow(true)}
                    color="primary">
                    Save
                  </Button>
                </Box>
              </Box>
              <BuzzTable
                // selectKey={'email'}
                // onSelect={(e) => getCheck(e)}
                columns={[
                  {
                    Header: 'Select',
                    Cell: (val) => {
                      const user = val.cell.row.original;
                      return (
                        <FormControlLabel
                          control={<Checkbox />}
                          // checked={userIds.includes(user._id)}
                          checked={emailIds.includes(user.email)}
                          label={user.name}
                          value={user.email}
                          onChange={(e) => getCheck(e)}
                        />
                      );
                    },
                  },
                  {
                    Header: 'Name',
                    accessor: 'name',
                  },
                  {
                    Header: 'Email',
                    accessor: 'email',
                  },
                  {
                    Header: 'Phone',
                    accessor: 'mobile',
                  },
                ]}
                data={users}
                isHandlePagination={true}
              />
              {/* <FormGroup>
                <Box display={'flex'} py={2} bgcolor={'#fff6f2'}>
                  <Box>
                    <Typography></Typography>
                  </Box>
                  <Box flex={1}>
                    <Typography>Name</Typography>
                  </Box>
                  <Box flex={1}>
                    <Typography>Email</Typography>
                  </Box>
                  <Box flex={1}>
                    <Typography>Phone</Typography>
                  </Box>
                  <Box flex={1}>
                    <Typography>Id</Typography>
                  </Box>
                </Box>
                {users &&
                  users.map((user) => (
                    <Box p={1} display={'flex'}>
                      <Box flex={1}>
                        <FormControlLabel
                          control={<Checkbox />}
                          // checked={userIds.includes(user._id)}
                          checked={emailIds.includes(user.email)}
                          label={user.name}
                          value={user._id}
                          onChange={(e) => getCheck(e)}
                        />
                      </Box>
                      <Box flex={1}>
                        <Typography>{user.email}</Typography>
                      </Box>
                      <Box flex={1}>
                        <Typography>{user.mobile}</Typography>
                      </Box>
                      <Box flex={1}>
                        <Typography>{user._id}</Typography>
                      </Box>
                    </Box>
                  ))}
              </FormGroup> */}
              {/* <Box display="flex" justifyContent="center" pb={3}>
                <BuzzPagination
                  // onClick={handlePageChange}
                  total={count}
                  pageNo={page}
                  defaultPage={1}
                  perPage={10}
                />
              </Box> */}
            </>
          ) : domain === 'PRODUCT' ? (
            <>
              <Typography>Select Course For Offer</Typography>
              <Box display="flex">
                <Box flex={1} justifyContent={'right'} my={2} display={'flex'}>
                  <Button
                    variant="outlined"
                    onClick={() => setShow(true)}
                    color="primary">
                    Back
                  </Button>
                  <Box mx={1} />
                  <Button
                    variant="contained"
                    onClick={() => setShow(true)}
                    color="primary">
                    Save
                  </Button>
                </Box>
              </Box>
              <FormGroup>
                <Grid container spacing={2}>
                  {productList &&
                    productList.map((product) => (
                      <Grid item xs={3}>
                        <Box boxShadow={2} p={1}>
                          <FormControlLabel
                            control={<Checkbox />}
                            checked={productIds.includes(product._id)}
                            label={product.title}
                            value={product._id}
                            onChange={(e) => getProductCheck(e)}
                          />
                          {/* <Typography>{product._id}</Typography> */}
                        </Box>
                      </Grid>
                    ))}
                </Grid>
              </FormGroup>
            </>
          ) : null}
        </Box>
      )}
    </Box>
  );
};

export default AddOfferForm;
